import {Form} from 'antd'
import {InputText} from '@/components/Form/index.mjs'
import QueryForm from '@/components/QueryForm.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {SelectBaseline} from '@/biz/baseline/index.mjs'

const SelectSver = ({prjId, value, onChange, ...props}) => {
    const _onChange = x => onChange(x?.sVer)

    return (
        <SelectBaseline
            allowClear
            prjId={prjId}
            onChange={_onChange}
            {...props}
        />
    )
}

export const FormItemBaseline = props => (
    <Form.Item
        label="基线"
        name="sVer"
        {...props}
    >
        <SelectSver allowClear />
    </Form.Item>
)

export default function FormChooseDesign({children, ...props}) {
    const map = useMapContext()
    const {prjId, sVer} = map.data

    return (
        <QueryForm
            initialValues={{sVer}}
            layout="vertical"
            {...props}
        >
            <FormItemBaseline prjId={prjId} />
            {children}
        </QueryForm>
    )
}

export const FormItemPrjNo = props => (
    <Form.Item
        label="项目编号"
        name="prjNo"
        {...props}
    >
        <InputText allowClear />
    </Form.Item>
)

export const FormChooseExternal = ({children, ...props}) => {
    return (
        <FormChooseDesign {...props}>
            <FormItemPrjNo />
            {children}
        </FormChooseDesign>
    )
}
